// extracted by mini-css-extract-plugin
export default {"main":"trabalha_main__hxxvG","section_1":"trabalha_section_1__YAVW+"};